export function cleanNumber(number) {
  if (!number) {
    return number;
  }
  return `${number}`.replace(/\D/g, "");
}

export const localToNumber = (n) => {
  if (!n || String(n).length === 0) {
    return 0;
  }
  return Number(n);
};

export function isNumber(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
}
